/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Tld_Pricing_Offered_LabelInputs */

const id_tld_pricing_offered_label = /** @type {(inputs: Tld_Pricing_Offered_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tawarkan ${i?.tld} ke reseller`)
};

const en_tld_pricing_offered_label = /** @type {(inputs: Tld_Pricing_Offered_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Offer ${i?.tld} to resellers`)
};

/**
* | output |
* | --- |
* | "Offer {tld} to resellers" |
*
* @param {Tld_Pricing_Offered_LabelInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_offered_label = /** @type {((inputs: Tld_Pricing_Offered_LabelInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Offered_LabelInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_offered_label(inputs)
	return id_tld_pricing_offered_label(inputs)
});